module.exports = __webpack_public_path__ + "static/media/4ODA12.89c4d7a4.jpg";